import React from 'react';
import { ActiveCallSelfView } from 'browser/components/Dashboard/VisitorFocused/ActiveCallSelfView';
import { ChatPopupIncomingVideo } from './IncomingVideo';
import { ChatPopupActiveCallToolbar } from './Toolbar';
import { UniqueVisitor } from 'types/user';
import { IncomingStreamAudio } from 'shared/components/IncomingStreamAudio';
import './style.less';

export const ChatPopupActiveCall: React.FC<{ visitor: UniqueVisitor }> = ({
  visitor,
}) => {
  return (
    <div className="ChatPopupActiveCall">
      <ChatPopupIncomingVideo visitorId={visitor.id} />
      <ActiveCallSelfView />
      <ChatPopupActiveCallToolbar />
      <IncomingStreamAudio />
    </div>
  );
};
